// TEMPORARY (temp/linked-customer): card on the customer page: link state, "Link to Booking Form", numbers 2 and 3.
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { DetailCard } from "../../Components/Needed";
import { linkedApi, useLinkedEnabled, BASE } from "./linkedApi";
import LinkedStatusPanel from "./LinkedStatusPanel";
import LinkedPhonesModal from "./LinkedPhonesModal";

const LinkedCustomerCard = ({ customerId, customer, base = BASE, isAdmin = false, canLink = true }) => {
    const enabled = useLinkedEnabled(base);
    const api = useRef(linkedApi(base)).current;
    const [state, setState] = useState(null); // null = loading
    const [busy, setBusy] = useState(false);
    const [showPhones, setShowPhones] = useState(false);

    useEffect(() => {
        if (!enabled) return undefined;
        let alive = true;
        setState(null);
        api.get(customerId).then((r) => { if (alive) setState(r.ok ? r.data?.state : "unknown"); });
        return () => { alive = false; };
    }, [enabled, api, customerId]);

    if (!enabled) return null;

    const link = async () => {
        setBusy(true);
        const r = await api.link(customerId);
        setBusy(false);
        if (r.ok) { toast.success(r.message || "Linking started"); setState(r.data?.state || "pending"); } else toast.error(r.message || "Could not start linking");
    };

    const testMode = customer?.testMode === true;
    return (
        <DetailCard title="Booking Form link (temporary)">
            {state === null ? <div className="text-muted small">Checking...</div> : ""}
            {state === "not_linked" || state === "unknown" ? (
                <div>
                    <div className="small text-muted mb-2">This customer is not in the Booking Form. Linking creates them there and keeps their details up to date (one way).</div>
                    {testMode ? <div className="small text-danger">Test-mode customers cannot be linked.</div>
                        : canLink ? <button type="button" className="btn btn-primary btn-sm" disabled={busy} onClick={link}>{busy ? "Starting..." : "Link to Booking Form"}</button>
                            : <div className="small text-muted">You do not have permission to link customers.</div>}
                </div>
            ) : ""}
            {state && !["not_linked", "unknown"].includes(state) ? (
                <LinkedStatusPanel customerId={customerId} base={base} isAdmin={isAdmin} onVerifyPhones={() => setShowPhones(true)} />
            ) : ""}
            {showPhones ? <LinkedPhonesModal customerId={customerId} base={base} onClose={() => setShowPhones(false)} /> : ""}
        </DetailCard>
    );
};

export default LinkedCustomerCard;
